const rinkebyJSON = {
  SINGLE_NFT721_JSON: "../Contracts/Rinkeby/NFT.json",
  SINGLE_NFT721_ADDRESS: "0x1e26712E340ec67aF92b9fba296d61952bBd94aF",
  MULTIPLE_NFT1155_JSON: "../MultNFT.json",
  MULTIPLE_NFT1155_ADDRESS: "0x8Fa4e40D1e6dC91a8e5794D65605314e247C1C02",
  ERC_20_JSON: "",
  ERC_20_ADDRESS: "0xc073d96aeDf584C44D1377736b0484Ad35C31978",
  ERC_20_ADDRESS_GFL:"",
  MARKET_PLACE_JSON: "../MarketPlace.json",
  MARKET_PLACE_ADDRESS: "0xf74eDAbA5E88d990DC0466158542612b81e434ea",
  MARKET_PLACE_1155_JSON: "../MarketPlace_1155.json",
  MARKET_PLACE_1155_ADDRESS: "0x6D5aF5A16E90E88caA759fC09da949891E271FAe",
  LAZY_MINT_JSON: "../LazyMint.json",
  LAZY_MINT_ADDRESS: "0x2f950875b17d5b8B521e04E41f45973b8c0D9aa8",
  BATCH_MINT_JSON: "../Batchmint.json",
  BATCH_MINT_ADDRESS: "0xFa3bb0c84c409bfBeB163B408Be4B7A5504C0B4A",
  BATCH_MINT_MARKETPLACE: "../BatchMarketPlace.json",
  BATCH_MINT_MARKETPLACE_ADDRESS: "0x65F25C156b534637cbBc9ebA7cdc6905C0dDFf44"

}

const Contracts_Matic = {
  SINGLE_NFT721_JSON: "../Contracts/Rinkeby/NFT.json",
  SINGLE_NFT721_ADDRESS: "asdlkfnasdlfkas;ldkfmasd;lkfmasd;lfkmasd;lckasd;cklnasd'nas;dlfcknasdck/l",
  MULTIPLE_NFT1155_JSON: "../MultNFT.json",
  MULTIPLE_NFT1155_ADDRESS: "ssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss",
  ERC_20_JSON: "",
  ERC_20_ADDRESS: "sddddddddddddddddfasdfaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",
  MARKET_PLACE_JSON: "../MarketPlace.json",
  MARKET_PLACE_ADDRESS: "dssssssssssssssssssssssssssssssssssssssssssssssssssssskkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk",
  MARKET_PLACE_1155_JSON: "../MarketPlace_1155.json",
  MARKET_PLACE_1155_ADDRESS: "0x968C74B1F515244141af5FDeEf2b851bC9f9af91",
  LAZY_MINT_JSON: "../LazyMint.json",
  LAZY_MINT_ADDRESS: "0xa64Fb7d36a2D6130788939166B1789D0Ec6C4940",
  BATCH_MINT_JSON: "../Batchmint.json",
  BATCH_MINT_ADDRESS: "0x53a668332B20689e7810451cd6cBe737D9F71201",
  BATCH_MINT_MARKETPLACE: "../BatchMarketPlace.json",
  BATCH_MINT_MARKETPLACE_ADDRESS: "0xbFaE970563E25042955E0D726465C6B09e87f028"
}

const Polygon = {
  SINGLE_NFT721_JSON: "../Contracts/Rinkeby/NFT.json",
  SINGLE_NFT721_ADDRESS: "0xcE97f17cDEbDD69477762f65317009146D220855",
  MULTIPLE_NFT1155_JSON: "../MultNFT.json",
  MULTIPLE_NFT1155_ADDRESS: "0x1769733B273f648A7f3b5340bB6858748986f664",
  ERC_20_JSON: "",
  ERC_20_ADDRESS: "0xEB698679Ad7Cd29F66726AB30a829b7e869DE58A",
  ERC_20_JSON_Kombat: "",
  ERC_20_ADDRESS_Kombat: "0x93F0C2203FcF0d55e8ec2fA98b1fBddfc5c5F837",
  MARKET_PLACE_JSON: "../MarketPlace.json",
  MARKET_PLACE_ADDRESS: "0x55B2F1c30E3ee2605bBb7644aCd664988945c983",
  MARKET_PLACE_1155_JSON: "../MarketPlace_1155.json",
  MARKET_PLACE_1155_ADDRESS: "0x2A48f4229fF18b8c3936f53969A2BAe0dFafD6Ef",
  LAZY_MINT_JSON: "../LazyMint.json",
  LAZY_MINT_ADDRESS: "0xB5C7A92661060684263a3291D15Ee9e724683527",
  BATCH_MINT_JSON: "../Batchmint.json",
  BATCH_MINT_ADDRESS: "0xD6eBdbB323C87761E4d4f6F8D1Eb6B2706D35c9d",
  BATCH_MINT_MARKETPLACE: "../BatchMarketPlace.json",
  BATCH_MINT_MARKETPLACE_ADDRESS: "0x0AB4a67Ff380557cA2A05E27d546a8dd770B3b8b",
  GFL_KP_EXCHANGE_JSON: "../Contracts/Rinkeby/GflKpExchange.json",
  GFL_KP_EXCHANGE_ADDRESS: "0xb6669Fa6ACE87B297982c0F0e0CfF90c4dd90126"
}

export {Polygon,rinkebyJSON};
// export const Contracts_Rinkeby = localStorage.getItem('networkName') ==  "Avalanche" ? Contracts_Matic : rinkebyJSON;
